module.exports = __webpack_public_path__ + "img/verificacao-autenticidade.a706d320.svg";